// src/services/BinanceService.js
import BaseApi from "./BaseApi";

class BinanceService extends BaseApi {
  constructor() {
    super("/binance");
  }
  
  // API get-coins 
  getCoins(params = {}) {
    return this.get("/get-coins", params);
  }               
  
  // API get-mkc-fmd
  getMkcFdm(coinList) {
    return this.post("/get-mkc-fdm", coinList);
  }


  // API get-longshort-acc
  getLongshortAcc(payload) {
    return this.post("/longshort-acc", payload);
  }

  // API get-longshort-poss
  getLongshortPoss(payload) {
    return this.post("/longshort-poss", payload);
  }

  // API get-longshort
  getLongshort(payload) {
    return this.post("/longshort", payload);
  }

  // API get-funding-rate
  getFundingRate(payload) {
    return this.post("/get-funding-rate", payload);
  }

  // API get-open-interest
  getOpenInterest(payload) {
    return this.post("/open-interest", payload);
  }

  // API get-day-large-inflow
  getDayLargeInflow(payload) {
    return this.post("/day-large-inflow", payload);
  }

  // API get-24hour-large-inflow
  get24HourLargeInflow(payload) {
    return this.post("/24hour-large-inflow", payload);
  }

  updateFavorite(payload) {
    return this.post("/update-favorite",payload);
  }
}

export default new BinanceService();